// Expiry is optional, if not set then cookie stays active till year 2035
import { FEATURES, MODULES } from '../constants/template-info'

import getCookieDomain from './getCookieDomain'
import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'

// /**
//  * @deprecated Use EnhancedCookie utility instead:
//  * ```typescript
//  * import { getCookie } from '@src/utils/enhancedCookie'
//  * setCookie(key, value, {
//  *   isGlobal: true,
//  *   expires: new Date('2035-05-18'),
//  *   secure: true,
//  *   domain: getCookieDomain()
//  * })
//  * ```
//  */
const setCookie = (
  name: string,
  value: string | undefined | boolean,
  expiryMinutes: number | undefined = undefined,
  isSecure: boolean | undefined = false,
  subDomainSharing = true,
) => {
  console.warn('setCookie is deprecated. Use EnhancedCookie utility instead.')
  if (!isBrowser()) return
  try {
    let expires = ''
    if (!expiryMinutes) {
      // eslint-disable-next-line i18next/no-literal-string
      expires = 'Fri, 17 May 2035 12:00:00 UTC'
    }
    if (expiryMinutes) {
      const date = new Date()
      date.setTime(date.getTime() + expiryMinutes * 60 * 1000)
      expires = date.toUTCString()
    }
    let cookie = `${name}=${value}; expires=${expires}; path=/`
    if (subDomainSharing) {
      cookie += `; domain=${getCookieDomain()}`
    }
    if (isSecure) {
      // eslint-disable-next-line i18next/no-literal-string
      cookie += '; Secure'
    }
    document.cookie = cookie
  } catch (error) {
    captureException('setCookie error', {
      module: MODULES.COOKIE_STORAGE,
      feature: FEATURES.SET_COOKIE,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'set cookie function',
        cookieKey: name,
        cookieValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

export default setCookie
